export const ACCESS_LOG_STATUS = { ERROR: 'ERROR', SUCCESS: 'SUCCESS', FAILED: 'FAILED' };
export const ACCESS_LOG_TYPE = { REFRESH: 'REFRESH', LOGIN: 'LOGIN', LOGOUT: 'LOGOUT', LOAD: 'LOAD' };
export const AUDIT_LOG_OPERATION = { CREATE: 'create', UPDATE: 'update', DELETE: 'delete' };
export const AUTHFROM_FORMALITY_TYPE = { WITNESSED: 'WITNESSED', RECORDED: 'RECORDED' };
export const AUTHFROM_RECOVERY_ORG = {
    SA: 'San_Antonio_Eye_Bank',
    CG: 'CorneaGen',
    LEB: 'Lions_Eye_Bank_of_Texas_at_Baylor_College_of_Medicine',
    LEBT: 'Lions_Eye_Bank_of_Texas',
};
export const PARTNER_TYPES = {
    ORGAN: 39,
    EYE: 40,
    TISSUE: 41,
};
export const AUTHFROM_TYPE = {
    SAN_ANTONIO_EYE: 'sanAntonioEyeOnly',
    FLORIDA: 'floridaAuthForm',
    RESEARCH: 'researchAuthForm',
    REGISTERED_TISSUE: 'registeredTissueDonorDisclosure',
    REGISTERED_DONOR: 'registeredDonorDisclosure',
    SAN_ANTONIO_TISSUE: 'sanAntonioTissue',
    CALIFORNIA_AUTH_FORM: 'californiaAuthForm',
    CALIFORNIA_RESEARCH_AUTH_FORM: 'californiaResearchAuthForm',
    CALIFORNIA_REGISTERED_DONOR: 'californiaRegisteredDonorDisclosure',
};
export const CASE_ASSIGNMENT_STATUS = {
    ASSIGNED: 'assigned',
    UNASSIGNED: 'unassigned',
    ACKNOWLEDGED: 'acknowledged',
    ACKNOWLEDGED_OTHER: 'acknowledgedByAnother',
    COMPLETE: 'complete',
};
export const CASE_FORM_STATUS = {
    IN_PROGRESS: 'In Progress',
    SIGNED_FINAL: 'Signed Final',
    NOT_STARTED: 'Not Started',
};
export const CASE_LOCK_STATUS = { LOCKED: 'LOCKED', UNLOCKED: 'UNLOCKED' };
export const CORONOR_AUTOPSY_STATUS = { COMPLETED: 'COMPLETED', PENDING: 'PENDING' };
export const DONATION_SUITABILITY = {
    TRANSPLANT: 'TRANSPLANT',
    RESEARCH: 'RESEARCH',
};
export const DONOR_WEIGHT_UNITS = { KG: 'kg', LBS: 'lbs' };
export const DONOR_HEIGHT_UNITS = { CM: 'cm', IN: 'in' };
export const DONOR_HYGIENE_STATUS = { GOOD: 'GOOD', POOR: 'POOR' };
export const DONOR_DEATH_DATE_TYPES = { ASYSTOLE: 'ASYSTOLE', LTKA: 'LTKA' };
export const DONOR_TEMPERATURE_UNITS = { F: 'F', C: 'C' };
export const DONOR_LACTATE_UNITS = { MGDL: 'mg_dL', MMOLL: 'mmol_L' };
export const DONOR_COOLING_TYPE = { OCULAR: 'OCULAR', BODY: 'BODY' };
export const DONATION_DISCUSSION_RESPONSE = { YES: 'Yes', NO: 'No', UNKNOWN: 'Unknown' };
export const DONATION_DISCUSSION_TYPE = {
    PLANNED: 'Planned',
    UNPLANNED: 'Unplanned',
    NO_DISCUSSION: 'No Discussion',
};
export const DRAI_TYPE = {
    UNIFORMDRAIGT12: 'uniformDraiGt12',
    UNIFORMDRAIBIRTHMOTHER: 'uniformDraiBirthMother',
    ADDENDUM: 'addendum',
    UNIFORMDRAILE12: 'uniformDraiLe12',
    EYEONLYUNIFORMDRAIGT12: 'eyeOnlyUniformDraiGt12',
    EYEONLYUNIFORMDRAILE12: 'eyeOnlyUniformDraiLe12',
};
export const ESIGN_STATUS = {
    NOT_STARTED: 'Not Started',
    IN_PROGRESS: 'In Progress',
    SIGNED_FINAL: 'Signed Final',
};
export const EYE_POSITION = { OS: 'OS', OD: 'OD' };
export const GROUP_ASSIGNMENT_MESSAGE_TYPE = {
    ASSIGNED: 'ASSIGNED',
    ACKNOWLEDGED_BY_OTHER_USER: 'ACKNOWLEDGED_BY_OTHER_USER',
};
export const ML_UNITS = { ML: 'mL', UNITS: 'Units' };
export const PHYSICAL_ASSESSMENT_ADDITIONAL_STAFF_TYPE = {
    OBSERVING: 'OBSERVING',
    SHADOWING: 'SHADOWING',
};
export const RECOVERY_METHODS = { IN_SITU: 'IN SITU', ENUCLEATION: 'ENUCLEATION' };
export const RESET_PASSWORD_STATUS = { ERROR: 'ERROR', SUCCESS: 'SUCCESS', FAILED: 'FAILED' };
export const RESET_PASSWORD_TYPE = { FORCED: 'FORCED', INITIATED: 'INITIATED' };
export const SEROLOGY_STATUS = { REACTIVE: 'REACTIVE', NON_REACTIVE: 'NON_REACTIVE', PENDING: 'PENDING' };
export const SEROLOGY_TYPE = { RECOVERY: 'RECOVERY', MEDICAL_REVIEW: 'MEDICAL_REVIEW' };
export const SEROLOGY_MORTEM = { PREMORTEM: 'PREMORTEM', POSTMORTEM: 'POSTMORTEM' };
export const SEROLOGY_RH = { POSITIVE: 'POSITIVE', NEGATIVE: 'NEGATIVE' };
export const SEROLOGY_ABO = {
    A: 'A',
    A1: 'A1',
    A2: 'A2',
    B: 'B',
    AB: 'AB',
    A1B: 'A1B',
    A2B: 'A2B',
    O: 'O',
    NOT_DONE: 'NOT_DONE',
};
export const SEROLOGY_BLOOD_TYPE = { SERUM: 'SERUM', PLASMA: 'PLASMA', WHOLE: 'WHOLE' };
export const SUPPLY_DATE_TYPE = {
    EXPIRATION: 'EXPIRATION',
    MANUFACTURER: 'MANUFACTURER',
    DATEOFUSE: 'DATEOFUSE',
};
export const TRANSMIT_INTERNAL = { INTERNAL: 'INTERNAL', EXTERNAL: 'EXTERNAL' };
export const TRANSMIT_RECEPIENT_TYPE = { USER: 'USER', ORGANIZATION: 'ORGANIZATION' };
export const TRANSMIT_CANTACT_TYPE = { EMAIL: 'EMAIL', FAX: 'FAX' };
export const TRANSMITLOG_STATUS = {
    COMPLETE: 'COMPLETE',
    PENDING: 'PENDING',
    RESEND: 'RESEND',
    DELIVERED: 'DELIVERED',
    DOWNLOADED: 'DOWNLOADED',
    ACCESSED: 'ACCESSED',
    EXPIRED: 'EXPIRED',
    ERROR: 'ERROR',
};
export const TRANSMISSION_ACCESS_STATUS = {
    DELIVERED: 'DELIVERED',
    ERROR: 'ERROR',
    ACCESSED: 'ACCESSED',
    DOWNLOADED: 'DOWNLOADED',
    EXPIRED: 'EXPIRED',
};
export const TRANSMISSION_ACCESS_LOG_ACTIONS = { EXTEND: 'EXTEND', RESEND: 'RESEND', EXPIRE: 'EXPIRE' };
export const TRANSMIT_DETAIL_TYPE = {
    ATTACHMENT: 'ATTACHMENT',
    PAGE: 'PAGE',
    PACKET: 'PACKET',
    CASE_NOTES: 'CASE_NOTES',
};
export const DISPATCH_TYPE = {
    ATTEMPT: 'Attempt',
    RESPONSE: 'Response',
};
export const DISPATCH_ON_SHIFT = {
    YES: 'Yes',
    NO: 'No',
};
export const DISPATCH_CONTACT_METHOD = {
    PHONE_CALL: 'Phone Call',
    TEXT: 'Text',
    EMAIL: 'Email',
    OTHER: 'Other',
};
export const DISPATCH_OUTCOME = {
    ANSWERED_ACCEPTED: 'Answered, accepted',
    NO_ANSWER: 'No Answer',
    ANSWERED_DECLINED: 'Answered, declined',
};
export const DISPATCH_REASON = {
    ALREADY_ON_CASE: 'Already on a Case',
    SHIFT_ENDING: 'Shift Ending',
    NOT_ON_SCHEDULE: 'Not on Schedule',
    DECLINED_TO_GIVE_REASON: 'Declined to Give Reason',
    TRANSPORTATION_ISSUES: 'Transportation Issues',
    ILLNESS: 'Illness',
    OTHER: 'Other',
    CHANGED_MIND: 'Changed Mind',
};
export const AUTHORIZATION_TYPE = {
    RESEARCH: 'Research',
    NON_REGISTERED_AUTHORIZATION: 'Non-registered Authorization',
    REGISTRY_NOTIFICATION: 'Registry Notification',
    DIRECT_DISPATCH: 'Direct Dispatch',
    PARTNER_AUTHORIZED: 'Partner Authorized',
};
export const JURISDICTION_STATUS = {
    ASSUMED: 1,
    NOT_ASSUMED: 2,
    PENDING: 3,
};
